import { render, staticRenderFns } from "./PanelCustomerSearch.vue?vue&type=template&id=2370c384&scoped=true&"
import script from "./PanelCustomerSearch.vue?vue&type=script&lang=ts&"
export * from "./PanelCustomerSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PanelCustomerSearch.vue?vue&type=style&index=0&id=2370c384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370c384",
  null
  
)

export default component.exports